import { sylvanus } from '~/services/serviceInstances';

import { PromptModelSummary } from '../../types/sylvanus/model';

type Response = PromptModelSummary;

export const getModelSummary = async () => {
  const response: Response = await sylvanus.get(`/models/summary`);

  return response;
};
